import service from "@/utils/request";

// 获取授权菜单
export const getAsyncMenu = () => {
  return service({
    url: "/api/v1/staff/menu",
    method: "get",
  });
};
